export default __webpack_public_path__ + "static/media/4-strings-chord-diagram.6e813f75.png";